export default __webpack_public_path__ + "static/media/pcb_process_design.2dd36e2a.png";